import headerSearchPropsSetup from 'mixins/composition/search/HeaderSearchProps';
import stateProviderSetup from 'mixins/composition/search/StateProvider';
import boundsProviderSetup from 'mixins/composition/search/BoundsProvider';
import ModalScrollBlockSetup from 'mixins/composition/search/ModalScrollBlocks';
import metaDataSetup from 'mixins/composition/search/MetaData';
// import fallbackRadiusSearchSetup from 'mixins/composition/search/FallbackRadiusSearch';
import searchRedirect from 'mixins/composition/search/SearchFunctions';
import { breakpoint, setupMediaQueries, killMediaListeners } from 'mixins/composition/DeviceHelper';
import getNumberFormat from 'mixins/composition/NumberFormat';
// eslint-disable-next-line import/no-unresolved

const getReducedCtx = (ctx) => ({
  app: ctx.root,
  store: ctx.root.$store,
  refs: ctx.refs,
  router: ctx.root.$router,
});

export { getReducedCtx };

export default (ctx) => {
  const reducedCtx = getReducedCtx(ctx);
  const metaData = metaDataSetup(reducedCtx);
  const { headerSearchSubtitle, showMultiHeadline, headerSearchTitleHtml } = headerSearchPropsSetup(reducedCtx);
  const {
    isSeoPage, isSeaPage, isPlace, country, region, totalObjects, ready, offerID,
    seoContent, locationTitle, locationBreadcrumbs, fullscreenmap, showModalStatus,
  } = stateProviderSetup(reducedCtx);
  const { mapBounds, boundsSource } = boundsProviderSetup(reducedCtx);
  // const { watchForRadiusSearch } = fallbackRadiusSearchSetup(reducedCtx);
  const { watchForModalChanges, searchModalInitialized, searchModalReady } = ModalScrollBlockSetup(reducedCtx);
  const { formatNumber } = getNumberFormat(ctx);
  return {
    setup: {
      watchForModalChanges,
      // watchForRadiusSearch,
      setupMediaQueries,
      killMediaListeners,
    },
    methods: {
      searchRedirect,
      formatNumber,
    },
    data: {
      metaData,
      // store states
      country,
      region,
      isSeaPage,
      isSeoPage,
      isPlace,
      totalObjects,
      ready,
      offerID,
      seoContent,
      locationTitle,
      locationBreadcrumbs,
      fullscreenmap,
      showModalStatus,
      // store states end
      // header search experiments and props
      headerSearchSubtitle,
      showMultiHeadline,
      headerSearchTitleHtml,
      // header search experiments and props end
      // misc
      breakpoint,
      // misc end
      // modal handling
      searchModalInitialized,
      searchModalReady,
      // modal handling end
      // map bounds
      mapBounds,
      boundsSource,
      // map bounds end
    },
  };
};
